import { Clock, CheckCircle2 } from "lucide-react";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export function PortalStatusHistory({ history }) {
  if (!history?.length) {
    return (
      <div className="bg-white border border-border rounded-xl p-5 text-sm text-muted-foreground" data-testid="portal-history-empty">
        Aún no hay movimientos registrados para tu vehículo.
      </div>
    );
  }
  const events = [...history].reverse();
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid="portal-status-history">
      <div className="flex items-center gap-2 mb-4">
        <Clock className="h-4 w-4" style={{ color: "var(--tenant-primary)" }} />
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Historial de tu vehículo</div>
      </div>
      <ol className="relative pl-7 space-y-5">
        <div className="absolute left-[9px] top-2 bottom-2 w-px bg-slate-200" />
        {events.map((ev, i) => (
          <li key={`${ev.at}-${i}`} className="relative" data-testid={`portal-history-item-${i}`}>
            <span className={`absolute -left-7 top-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white ${ev.is_current ? "" : "bg-slate-300"}`}
              style={ev.is_current ? { background: "var(--tenant-primary)", boxShadow: "0 0 0 4px rgba(15,23,42,0.08)" } : undefined}>
              {ev.is_current && <CheckCircle2 className="h-3 w-3 text-white" />}
              {ev.kind === "quote_rejected" && <span className="h-2 w-2 rounded-full bg-red-500" />}
            </span>
            <div className={`text-sm ${ev.is_current ? "font-semibold text-slate-900" : "text-slate-700"}`} data-testid={ev.is_current ? "portal-history-current" : undefined}>
              {ev.label}
              {ev.is_current && <span className="ml-2 align-middle text-[10px] font-medium px-1.5 py-0.5 rounded text-white" style={{ background: "var(--tenant-primary)" }}>Actual</span>}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">{fmtDate(ev.at)} · {ev.actor}</div>
            {ev.public_note && <div className="text-sm text-slate-700 mt-1.5 bg-slate-50 border border-slate-100 rounded-md px-3 py-2" data-testid={`portal-history-note-${i}`}>{ev.public_note}</div>}
          </li>
        ))}
      </ol>
    </div>
  );
}

export function PortalDiagnosis({ diagnosis }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid="portal-diagnosis">
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-3">Diagnóstico del taller</div>
      {!diagnosis ? (
        <p className="text-sm text-muted-foreground" data-testid="portal-diagnosis-empty">El taller aún no ha registrado un diagnóstico.</p>
      ) : (
        <div className="space-y-3 text-sm">
          <div className="text-xs text-muted-foreground">
            {[diagnosis.type_label, fmtDate(diagnosis.date), diagnosis.technician && `Responsable: ${diagnosis.technician}`].filter(Boolean).join(" · ")}
          </div>
          {diagnosis.findings && <Block title="Lo que encontramos" text={diagnosis.findings} testId="portal-diagnosis-findings" />}
          {diagnosis.recommendation && <Block title="Recomendación" text={diagnosis.recommendation} testId="portal-diagnosis-recommendation" />}
          {diagnosis.customer_notes && <Block title="Notas para ti" text={diagnosis.customer_notes} testId="portal-diagnosis-notes" />}
          {!diagnosis.findings && !diagnosis.recommendation && !diagnosis.customer_notes && (
            <p className="text-muted-foreground">El diagnóstico está en proceso. Te avisaremos cuando haya resultados.</p>
          )}
        </div>
      )}
    </div>
  );
}

function Block({ title, text, testId }) {
  return (
    <div data-testid={testId}>
      <div className="font-medium text-slate-900">{title}</div>
      <p className="text-slate-700 whitespace-pre-line mt-0.5">{text}</p>
    </div>
  );
}
